import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addOrderLine,
  deleteOrder,
  deleteOrderLine,
  getCalculateOrderLinesSubTotal,
  getEmployeeFilterList,
  getOrderList,
  getOrderListByID,
  getOrderStatus,
  getOrderTypesData,
  getOutletFiltersData,
  printOrder,
  productByPricebookId,
  rejectOrder,
  updateAcceptOrder,
  updateOrderLine,
} from "./POBRepository";
// import { toast } from "react-toastify";
// import { queryClient } from "../../../Api/queryClient";
import { showToast } from "../../../utils/toastUtils";
import { useCallback } from "react";

export const useOrderListData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORDER_LIST", params],
    queryFn: () => getOrderList(params),
    enabled: enable,
    retry: false,
  });
};

export const useOrderListByIdData = ({
  id,
  params = {},
  enable = false,
}: { id?: any; params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORDER_LIST", id, params],
    queryFn: () => getOrderListByID(id, params),
    enabled: enable,
    retry: false,
  });
};

export const useUpdateAcceptOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // queryKey: ["ORDER_LIST", id],
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      updateAcceptOrder(id, body),
    onSuccess: (data) => {
      showToast.success("Update Order List Successfully!");
      queryClient.invalidateQueries({
        queryKey: ["ORDER_LIST"],
      });
    },
    onError: (error) => {
      showToast.warning("Failed to Update Order List!");
    },
  });
};

export const useDeleteOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // queryKey: ["ORDER_LIST", id],
    mutationFn: ({ id }: { id: number }) => deleteOrder(id),
    onSuccess: (data) => {
      showToast.success("Delete Order Successfully!");
      queryClient.invalidateQueries({
        queryKey: ["ORDER_LIST"],
      });
    },
    onError: (error) => {
      showToast.warning("Failed to Delete Order!");
    },
  });
};

// printOrder
// export const usePrintOrderData = ({
//   id,
//   enable = false,
// }: { id?: any; enable?: boolean } = {}) => {
//   return useQuery({
//     queryKey: ["ORDER_LIST_BY_ID", id],
//     queryFn: () => printOrder(id),
//     enabled: enable,
//     retry: false,
//   });
// };

export const useProductsByPricebookIdData = ({
  id,
  enable = false,
}: { id?: any; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORDER_LIST_BY_ID", id],
    queryFn: () => productByPricebookId(id),
    enabled: enable,
    retry: false,
  });
};

export const useAddOrderLines = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      addOrderLine(id, body),
    onSuccess: (data) => {
      showToast.success("Add Order Lines Successfully!!");
      queryClient.invalidateQueries({ queryKey: ["ORDER_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Order Lines!");
    },
  });
};

// getEmployeeFilterList
export const useEmployeeFilterListData = ({
  enable = false,
  params,
}: { enable?: boolean; params?: any } = {}) => {
  return useQuery({
    queryKey: ["EPLOYEE_FILTER_LIST", params],
    queryFn: () => getEmployeeFilterList(params),
    enabled: enable,
    retry: false,
  });
};

export const useOrderStatusData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORDER_STATUS"],
    queryFn: () => getOrderStatus(),
    enabled: enable,
    retry: false,
  });
};

// getCalculateOrderLinesSubTotal
export const useCalculateOrderLinesSubTotal = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORDER_LIST_BY_ID", params],
    queryFn: () => getCalculateOrderLinesSubTotal(params),
    enabled: enable,
    retry: false,
  });
};

export const useUpdateOrderLines = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      updateOrderLine(id, body),
    onSuccess: (data) => {
      showToast.success("Update Order Line!");
      queryClient.invalidateQueries({ queryKey: ["ORDER_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Update Order Line!");
    },
  });
};

export const useDeleteOrderLines = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      deleteOrderLine(id, body),
    onSuccess: (data) => {
      showToast.success("Delete Order Line!");
      queryClient.invalidateQueries({ queryKey: ["ORDER_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Delete Order Line!");
      console.log("errorrr", error);
    },
  });
};

// getOrderTypesData
export const useOrderTypes = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["POB_ORDER_TYPES"],
    queryFn: getOrderTypesData,
    enabled: enable,
    retry: false,
  });
};

// getOutletFiltersData
export const useOutletFilters = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["POB_OUTLET_FILTERS", params],
    queryFn: () => getOutletFiltersData(params),
    enabled: enable,
    retry: false,
  });
};

// rejectOrder
export const useRejectOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      rejectOrder(id, body),
    onSuccess: (data) => {
      showToast.success("Reject Order Successfully!");
      queryClient.invalidateQueries({ queryKey: ["ORDER_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Reject Order!");
    },
  });
};

// printOrder
export const usePrintOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      printOrder(id, body),
    onSuccess: (data) => {
      showToast.success("Print Order Successfully!");
      queryClient.invalidateQueries({ queryKey: ["ORDER_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Print Order!");
    },
  });
};
